<template>
  <span class="animated-number" v-html="formatToPrice"></span>
</template>

<script setup>
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'

import { numberFilter } from 'src/common/functions'

const props = defineProps({
  value: {
    type: Number,
    default: null,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 2,
  },
  currency: {
    type: [String, Boolean],
    default: false,
  },
})

const STEP = 10
const DURATION = 1000

const output = ref(0)
const interval = ref(null)

const formatToPrice = computed(() => numberFilter(output.value ?? 0, props.currency, props.min, props.max))

function animationNumber() {
  interval.value = setInterval(() => {
    output.value = output.value + ((props.value - output.value) * STEP) / DURATION
  }, STEP)
  setTimeout(() => {
    output.value = props.value
    clearInterval(interval.value)
  }, DURATION)
}

onBeforeMount(() => {
  output.value = props.value
})

onBeforeUnmount(() => {
  clearInterval(interval.value)
})

watch(
  () => props.value,
  () => {
    animationNumber()
  }
)
</script>

<style lang="scss">
.animated-number {
  white-space: nowrap;
}
</style>
